module.exports = __webpack_public_path__ + "static/media/farol copy 34.7d79a4f8.MP4";